import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Output} from '@angular/core';

@Component({
    selector: 'app-tag',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ng-content></ng-content>
        <span class="tag__remove" (click)="onRemoveClickHandle()">
            <lib-icon type="cross" [size]="10" [align]="'top'"></lib-icon>
        </span>
    `
})

export class TagComponent {
    @Output() remove = new EventEmitter<any>();

    @HostBinding('class') className = 'tag';

    onRemoveClickHandle() {
        this.remove.emit();
    }
}
